import {TD_NEWS} from '../config/paths/apiPaths';
import {getTdNews, saveTdNews} from "../indexedDb/tdNewsDb";
import request from "../utils/request";


export default {
  namespaced: true,

  state: {
    news: [],
  },

  mutations: {
    setTdNews(state, news) {
      state.news = news;
    }
  },

  actions: {
    async getTdNews({commit}) {

      // get from indexedDB first
      const storedNews = await getTdNews();
      commit('setTdNews', storedNews);

      const response = await request(TD_NEWS);

      // if there is response, insert data to indexedDB
      if (response) {
        saveTdNews(response.data);
        commit('setTdNews', response.data);
      }
    },
  },

  getters: {},


}
